/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2023-08-11 10:23:56
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-02-26 15:28:14
 * @FilePath: \baishu_react_ui\src\components\BsyFlowMessage\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import React, { Component } from 'react'
import { withRouter } from "react-router-dom";
import './index.css';
import BsyFormPane from '../BsyFormPane';
import { setPageTitle } from '../../utils/setPageTitle';

class BsyFlowMessage extends Component {

  constructor(props) {
    super(props);

    let $flowtype = 'todo';
    switch (props.match.params.type) {
      case '':
        break;
      case 'create':
        break;
      case 'flow_forward':
        break;
      case 'flow_cc':
        $flowtype = "cc";
        break;
      case 'flow_back':
        break;
      case 'flow_urge':
        break;
      default: {
        break;
      }
    }
    this.state = {
      appid: props.match.params.appid,
      data: props.match.params.dataid,
      form: props.match.params.entryid,
      flowtype: $flowtype,
      flowid: props.match.params.flowid,

    }

    this.input = React.createRef();
  }

  componentDidMount = () => {
    const { appid, form, data, flowtype, flowid } = this.state

    this.setState({
      formConfig: {
        appId: appid,
        entryId: form,
        flowId: parseInt(flowid),
        flowType: flowtype,
        // _id: data,
        dataId: data,
      }
    })

  }


  render() {
    const { appid, formConfig } = this.state

    return (
      <div className='bsy-flow-message-view' ref={this.input} >

        {
          formConfig && formConfig.appId ? <BsyFormPane
            {...formConfig}
            loading={false}
            width={'80%'}
            mode={"edit"}
            source={'flow-message'}
            onShowDocumentTitle={e => {
              setPageTitle( e);
            }}
            onSuccess={(e, data) => {
              if (data.needPrint) {
                return
              }
              window.location.href = (`${window.rootDirectroy}/team/app/${appid}`)
            }}
            onClose={e => {
              window.location.href = (`${window.rootDirectroy}/team/app/${appid}`)
            }}
          > </BsyFormPane> : ''
        }

      </div>
    )
  }
}

export default withRouter(BsyFlowMessage) 
